/**
 *  Description: This file routes to login Page and also provides Navigation to
                  different Pages.

 * @author {Cognizant Technology Solution} gnet_react\src\router\RouterNavigation.js
 */
/* istanbul ignore file */
// @flow
import * as React from "react";
import { Suspense } from "react";
import { Container } from "react-bootstrap";
import { Switch, Route, useLocation } from "react-router-dom";
import { AuthenticatedTemplate } from "@azure/msal-react";
// import ErrorPage from "../common/components/errorBoundary/errorPage/ErrorPage";
import { IS_OUTAGE, KITENETNEWSDETAILS, KITENET_NEWSROOM, KITE_NET, NEWSDETAILS, NEWS_ROOM, USER_PROFILE } from "../constants/Constant";
import useHttp from "../dataService/UseHttp";
import { Spinner } from "react-bootstrap";


const NewsDetails = React.lazy(() =>
  import("../modules/home/newsDetails/NewsDetails")
);
const Home = React.lazy(() => import("../modules/home/Home"));
const KiteNet = React.lazy(() => import("../modules/kiteNet/KiteNet"));
const KiteNetNewsRoom = React.lazy(() =>
  import("../modules/kiteNetNewsRoom/KiteNetNewsRoom")
);
const KiteNewsDetails = React.lazy(() =>
  import("../modules/kiteNet/newsDetails/KiteNewsDetailsAPI")
);
const NewsRoom = React.lazy(() => import("../modules/newsRoom/newsRoom"));
const TopLayer = React.lazy(() => import("../modules/header/TopLayer"));
const BottomLayer = React.lazy(() => import("../modules/footer/BottomLayer"));
const UserProfileReq = React.lazy(() =>
  import("../modules/userProfilePage/userProfileReq")
);
const SearchResult = React.lazy(() =>
  import("../modules/searchResult/SearchResult")
);
const BookmarkModal = React.lazy(() =>
  import("../common/components/bookmark/BookmarkModal")
);
// const OutagePage = React.lazy(() =>
//   import("../modules/outagePage/outagePage")
// );
//const topBannerReducerDataCheck1 = useSelector((state) => state.userAuth?.countdownclockBnr);
// console.log(topBannerReducerDataCheck1)
const WelcomeGnet = React.lazy(() => import("./../modules/welcomegnet/WelcomeGnet"));


function RedirectToSharepointSite() {
  React.useEffect(() => {
    window.location.href = process.env.REACT_APP_SHAREPOINT_APP_URL;
  }, []);

  return <div className="redirectingMSAL">
    <Spinner animation="border" variant="secondary" /> Redirecting to
    Login Portal
  </div>
}


function RouterNavigation() {

  const [pilotUser, setPilotUser] = React.useState(false)
  const [isRedirecting, setIsRedirecting] = React.useState(false)
  const [sendHttpRequest, loading] = useHttp();
  const location = useLocation();

  React.useEffect(() => {
    sendHttpRequest({
      url: `${IS_OUTAGE.endpoint}?api-version=2`,
    }).then((data) => {
      setPilotUser(data.Response.isPilotUser)
    });
  }, [])


  React.useEffect(() => {
    // if (pilotUser) {

      // const currentPath = location.pathname.toLowerCase();
      // const allowedPaths = ['/', '/home'];
      // const shouldRedirect = allowedPaths.includes(currentPath);

      // if (shouldRedirect) {
        setIsRedirecting(true);
        window.location.href = process.env.REACT_APP_SHAREPOINT_APP_URL;
      // }
    // }
  }, [pilotUser, location.pathname]);


  if (loading || isRedirecting) {
    return <div className="redirectingMSAL">
      <Spinner animation="border" variant="secondary" /> Redirecting to
      Login Portal
    </div>
  }

  return (

    <AuthenticatedTemplate>
      <div>
        <Suspense fallback={<></>}>
          <Route path="/" component={TopLayer}></Route>
          <Container role="main">
            <Route path="/" component={BookmarkModal} />
            <Route path="/" component={WelcomeGnet} />
            <Switch>
              <Route path="/" component={Home} exact />
              <Route
                path={`${NEWSDETAILS}/:ItemName/:Preview?`}
                component={NewsDetails}
                exact
              />
              <Route path={`${NEWS_ROOM}/:Preview?`} component={NewsRoom} exact />
              <Route path={`${USER_PROFILE}/:EmailId?/:Preview?`} component={UserProfileReq} exact />
              <Route path="/SearchResult" component={SearchResult} exact />
              <Route
                path={`${KITENET_NEWSROOM}/:Preview?`}
                component={KiteNetNewsRoom}
                exact
              />
              <Route
                path={`${KITENETNEWSDETAILS}/:ItemName/:Preview?`}
                component={KiteNewsDetails}
                exact
              />
              <Route path={`${KITE_NET}/:Preview?`} component={KiteNet} exact />
              <Route path="/Home/:Preview?" component={Home} exact />
              <Route path="*">
                {/* {
                  pilotUser ? */}
                  <RedirectToSharepointSite />
                  {/* :
                  <ErrorPage fallbackUI={false} userNotFound={false} />
                } */}
              </Route>
            </Switch>
          </Container>
          <Route path="/" component={BottomLayer}></Route>
        </Suspense>
      </div>
    </AuthenticatedTemplate>
  );
}

export default RouterNavigation;
